import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import footerimage from "../../images/spark.png";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      {/* Footer Main */}
      <div
        className="footer-main bg-contain"
        style={{
          background: "linear-gradient(45deg, #002266, #000436)",
          paddingBottom: "0",
          
        }}
      >
        <div className="footer-top" style={{ marginTop: "-6rem" }}>
          <Container style={{ padding: "0" }}>
            <Row className="footer-custom-row" style={{ gap: "0", marginTop: "6rem" , paddingTop: "63px", paddingBottom: "63px"}}>
              {/* Brand Widget */}
              <Col md={6}>
                <div
                  className="footer-widget footer-widget-brand"
                  data-aos="fade-up"
                  data-aos-anchor=".footer-top"
                >
                  <Link className="footer-logo" to="/" aria-label="SparkLab Logo">
                    <img
                      src={footerimage}
                      alt="SparkLab Logo"
                      width="189"
                      height="32"
                      loading="lazy"
                    />
                  </Link>
                  <p className="text text-16">
                   Spark Lab is a creative digital agency focused on innovation, design, and technology. We help businesses grow through smart solutions, powerful branding, and meaningful digital experiences. Let’s spark your next big idea together.
                  </p>
                  <ul
                    className="social-icons list-unstyled d-flex gap-2"
                    data-aos="fade-up"
                    data-aos-anchor=".footer-top"
                  >
                    <li>
                      <a
                        className="social-link text"
                        href="https://web.facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFacebookF />
                        <span className="visually-hidden">Facebook</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="social-link text"
                        href="https://www.linkedin.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaLinkedinIn />
                        <span className="visually-hidden">LinkedIn</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="social-link text"
                        href="https://x.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaTwitter />
                        <span className="visually-hidden">Twitter</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="social-link text"
                        href="https://www.instagram.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaInstagram />
                        <span className="visually-hidden">Instagram</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>

              {/* Quick Links & Services & Info */}
              <Col md={6}>
                <Row style={{ gap: "0" }}>
                  <Col md={4}>
                    <div
                      className="footer-widget footer-widget-menu"
                      data-aos="fade-up"
                      data-aos-anchor=".footer-top"
                    >
                      <div className="widget-heading heading text-22">
                        Quick Links
                      </div>
                      <ul className="footer-menu list-unstyled">
                        <li>
                          <Link to="/" className="text text-16 link">Home</Link>
                        </li>
                        <li>
                          <Link to="/AboutUs" className="text text-16 link">About Us</Link>
                        </li>
                        <li>
                          <Link to="/Services" className="text text-16 link">Services</Link>
                        </li>
                        <li>
                          <Link to="/Blogs" className="text text-16 link">Blogs</Link>
                        </li>
                        <li>
                          <Link to="/Events" className="text text-16 link">Events</Link>
                        </li>
                        <li>
                          <Link to="/Contact_Us" className="text text-16 link">Contact Us</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div
                      className="footer-widget footer-widget-menu"
                      data-aos="fade-up"
                      data-aos-anchor=".footer-top"
                    >
                      <div className="widget-heading heading text-22">
                        Services
                      </div>
                      <ul className="footer-menu list-unstyled">
                        <li>
                          <Link to="/LogoDesign" className="text text-16 link">Logo Design</Link>
                        </li>
                        <li>
                          <Link to="/AppDevelopment" className="text text-16 link">App Development</Link>
                        </li>
                        <li>
                          <Link to="/WebsiteDevelopment" className="text text-16 link">Website Development</Link>
                        </li>
                        <li>
                          <Link to="/SEO" className="text text-16 link">SEO</Link>
                        </li>
                        <li>
                          <Link to="/DigitalServices" className="text text-16 link">Digital Services</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div
                      className="footer-widget footer-widget-menu"
                      data-aos="fade-up"
                      data-aos-anchor=".footer-top"
                    >
                      <div className="widget-heading heading text-22">
                        Information
                      </div>
                      <ul className="footer-menu list-unstyled">
                        <li>
                          <Link to="/Privacy" className="text text-16 link">Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to="/Condition" className="text text-16 link">Terms & Conditions</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom " style={{ marginTop: "-9rem", marginTop: "-134px" }}>
          <Container style={{ padding: "0" }}>
            <Row className="align-items-center" style={{ gap: "0" , marginTop: "41px", marginBottom: "0" }}>
              <Col md={6}>
                <div className="footer-copyright text text-16">
                  &copy; {new Date().getFullYear()} SparkLab. All rights reserved.
                </div>
              </Col>
              <Col md={6} className="footer-bottoms">
                <ul className="footer-menu footer-policies list-unstyled d-flex justify-content-end gap-3 mb-0">
                  <li>
                    <Link to="/Privacy" className="text text-16 link">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/Contact_Us" className="text text-16 link">Contact</Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
